<template>
    <div id="credit_note_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="creditNoteHeader" v-if="$route.params.id > 0">Update Credit/Debit Note</span>
                    <span class="page-title" id="creditNoteHeader" v-else>Add Credit/Debit Note</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="goPreviousPath">
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content debit-note-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="creditNoteForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div v-if="$route.params.id > 0" class="col form-group mt-4">
                                        <label class="control-label width-50" for="note_number">Note Number #: </label>
                                        <span class="label font-bold">{{note_number}}</span>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="note_type">Type:</label>
                                        <v-select v-model="note_type" name="note_type" placeholder="Select Type."
                                                label="text"
                                                :options="noteTypesArr" id="note_type" class="close-remove" :disabled="disableNoteTypeField">
                                        </v-select>
                                        <div class="field-error">{{note_type_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="reference">Reference#:</label>
                                        <input type="text" class="form-control" v-model="reference" id="reference" placeholder="Enter Reference" name="reference">
                                    </div>
                                    <template v-if="showCreditNoteFields">
                                        <div class="col form-group">
                                            <label class="control-label require" for="customer_id">Customer:</label>
                                            <v-select v-model="customer_id" name="customer_id" id="customer_id" label="text" :filterable="false" :options="customerArr" @search="onSearchCustomer" placeholder="Select Customer" class='custom-ci-auto-search' v-on:change="loadCustomerInvoices()">
                                                <template slot="no-options">
                                                    Search Customer...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="field-error">{{ customer_error_msg }}</div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label require" for="invoice_id">Invoice:</label>
                                            <v-select v-model="invoice_id" name="invoice_id" id="invoice_id" label="text" :filterable="false" :options="invoiceArr" @search="onSearchInvoice" placeholder="Select Invoice" class='custom-ci-auto-search'>
                                                <template slot="no-options">
                                                    Search Invoice...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="field-error">{{ invoice_error_msg }}</div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="col form-group">
                                            <label class="control-label require" for="vendor">Vendor:</label>
                                            <v-select v-model="vendor" name="vendor" id="vendor" label="text" :filterable="false" :options="vendorArr" @search="onSearchVendor" placeholder="Select Vendor" class='custom-ci-auto-search' v-on:change="loadVendorBills()">
                                                <template slot="no-options">
                                                    Search Vendor...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="field-error">{{ vendor_error_msg }}</div>
                                        </div>
                                        <div class="col form-group">
                                            <label class="control-label require" for="bill">Vendor Invoice:</label>
                                            <v-select v-model="bill" name="bill" id="bill" label="text" :filterable="false" :options="billArr" @search="onSearchBill" placeholder="Select Bill" class='custom-ci-auto-search'>
                                                <template slot="no-options">
                                                    Search Vendor Invoice...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                            </v-select>
                                            <div class="field-error">{{ bill_error_msg }}</div>
                                        </div>
                                    </template>
                                    <div class="col form-group">
                                        <label class="control-label require">Date of Issue:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="date_of_issue" name="date_of_issue" v-model="date_of_issue" :config="optionsDate" aria-describedby="basic-addon3"></date-picker>
                                            <label for="date_of_issue" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{date_of_issue_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label">Expiry Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="expiry_date" name="expiry_date" v-model="expiry_date" :config="optionsDueDate" aria-describedby="basic-addon3"></date-picker>
                                            <label for="expiry_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="reference">Reason:</label>
                                        <input type="text" class="form-control" v-model="reason" id="reason" placeholder="Enter Reason" name="reason">
                                        <div class="field-error">{{reason_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="sales_user_id">Sales User:</label>
                                        <v-select v-model="sales_user_id" name="sales_user_id" id="sales_user_id" label="text" :filterable="false" :options="userArr" @search="onSearchSalesUser" placeholder="Select Sales User" class='custom-ci-auto-search'>
                                            <template slot="no-options">
                                                Search User...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="location_id">Location:</label>
                                        <v-select v-model="location_id" name="location_id" placeholder="Select Location."
                                                label="text"
                                                :options="locationArr" id="location_id">
                                        </v-select>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label" for="notes">Notes:</label>
                                        <textarea class='form-control' v-model="notes" name="notes" ref="textarea" id="notes" rows="3"></textarea>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="notes">Terms &amp; Conditions:</label>
                                        <textarea class='form-control' v-model="term_conditions" name="term_conditions" ref="textarea" id="term_conditions" rows="3"></textarea>
                                    </div>
                                </div>
                                <div class="purchase-order-create-main table-responsive-sm">
                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" class="require" style="width:200px">Item</th>
                                                <th scope="col" class="require">Description</th>
                                                <th scope="col" class="require">Quantity</th>
                                                <th scope="col" class="require">Unit Price</th>
                                                <th scope="col">Amount</th>
                                                <th scope="col" style="width:200px">Tax</th>
                                                <th scope="col">Total</th>
                                                <th scope="col"> Action </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(row, index) in rows" :key="index">
                                                <td>
                                                    <v-select v-model="row.item_id" name="item_id" id="item_id"
                                                                label="text" :filterable="false" :options="componentArr"
                                                                @search="onSearchComponent"
                                                                placeholder="Select Item" class="custom-ci-auto-search contract-data">
                                                        <template slot="no-options">
                                                        Search Item...
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                        <div class="d-center">
                                                            {{ option.text }}
                                                        </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                        <div class="selected d-center">
                                                            {{ option.text }}
                                                        </div>
                                                        </template>
                                                    </v-select>
                                                    <div class="field-error">{{row.item_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <input type="text" v-model="row.description" name="description" placeholder="Description"
                                                    class="vgt-input">
                                                    <div class="field-error">{{row.desc_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <input type="text" placeholder="Quantity" v-model="row.item_qty" name="item_qty" v-on:keyup="calculateAmount($event,index)" id="item_qty" class="vgt-input text-right"
                                                    @keypress="isNumberCheck($event,index, 'qty')">
                                                    <div class="field-error">{{row.item_qty_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <input type="text" placeholder="Unit Price" v-model="row.item_price"
                                                    @input="validateInput($event,index)"
                                                    v-on:keyup="calculateAmount($event,index)" @keypress="isNumberCheck($event,index, 'price')" name="unit_price" class="vgt-input text-right">
                                                    <div class="field-error">{{row.item_price_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <input type="text" disabled placeholder="Amount"  v-model="row.item_amount" v-on:keyup="calculateAmount($event,index)" id="amount" name="amount" class="vgt-input text-right">
                                                </td>
                                                <td>
                                                    <v-select v-model="row.tax_id" name="tax_id" placeholder="Select Tax." label="text" :options="taxesArr" @input="onTaxSelect($event,index)">
                                                    </v-select>
                                                </td>
                                                <td>
                                                    <input type="text" disabled placeholder="Total"  v-model="row.item_total" id="item_total" name="item_total" class="vgt-input text-right">
                                                </td>
                                                <td>
                                                    <template v-if="rows.length != 1">
                                                        <span class="close-row"> <a href="javascript:void(0);" v-on:click="removeItem(index);"> × </a></span>
                                                    </template>
                                                    <template v-else>
                                                        <span class="close-row"> _ </span>
                                                    </template>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary">
                                        <i class="fp-add"></i> Add Line Item
                                    </button>
                                </div>
                                <div class="order-summary mt-4" v-if="showTotalSummary">
                                    <div class="row">
                                        <div class="col-md-6 offset-md-6">
                                            <div class="bg-white radius-5 p-3">
                                                <label class="font-bold"> SUMMARY </label>
                                                <table aria-describedby="table" class="table table-sm table-bordered">
                                                    <tr class="table-secondary">
                                                        <td> Subtotal: </td>
                                                        <td class="text-right"> ${{sub_total.toFixed(2)}} </td>
                                                    </tr>
                                                    <tr>
                                                        <td> Tax Amount: </td>
                                                        <td class="text-right"> ${{total_tax.toFixed(2)}} </td>
                                                    </tr>

                                                    <tr class="table-secondary">
                                                        <td> Total: </td>
                                                        <td class="order-total text-right"> ${{total.toFixed(2)}} </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" :disabled='isDisableStore' id="CreateCreditNoteBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateCreditNote" >
                                        <i class="fp-update"> </i>  Update
                                    </button>
                                    <button type="submit" :disabled='isDisableStore' id="CreateCreditNoteBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateCreditNote" >
                                        <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" :disabled='isDisableStore' id="createAndContinueCreditNoteBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateCreditNote(flag='Save and Continue')" >
                                        <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelCreditNoteBtn" class="btn btn-tertiary" v-on:click.prevent="goPreviousPath">
                                        <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';

import moment from 'moment';
export default {
    name: "CreditNoteCreate",
    metaInfo() {
        return {
            title: (this.$route.params.id > 0)? "Update Credit-Debit Note | " +process.env.COPYRIGHT_NAME : "Create Credit-Debit Note | " +process.env.COPYRIGHT_NAME
        }
    },
    
    mixins:[commonMixins,contractMixins],
    data: () => ({
        isDisableStore: false,
        permissions: [],
        cantAccessPage: "",
        loading:false,
        location_id:null,
        locationArr:[],
        note_type:{text:"Credit Note",value:"credit_note"},
        noteTypesArr:[
            {text:"Credit Note",value:"credit_note"},
            {text:"Debit Note",value:"debit_note"}
        ],
        note_type_error_msg:"",
        customerArr:[],
        customer_id:null,
        customer_error_msg:"",
        invoiceArr:[],
        invoice_id:null,
        invoice_error_msg:"",
        vendorArr:[],
        vendor:null,
        vendor_error_msg:"",
        billArr:[],
        bill:null,
        bill_error_msg:"",
        userArr:[],
        sales_user_id:null,
        reference:"",
        date_of_issue:"",
        date_of_issue_error_msg:"",
        expiry_date:"",
        reason:"",
        reason_error_msg:"",
        notes:"",
        term_conditions:"",
        optionsDate: {
            format: 'MM/DD/YYYY',
            useCurrent: true,
        },
        optionsDueDate: {
            format: 'MM/DD/YYYY',
            useCurrent: false,
        },
        rows:[],
        showCreditNoteFields:true,
        disableNoteTypeField:false,
        note_number:"",
        sub_total:0,
        total_tax:0,
        total:0,
        taxesArr:[],
        componentArr:[],
        showTotalSummary:false
    }),
    watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_credit_note') {
                        self.cantAccessPage = true;
                    }
                }
            }

        },
        note_type: function (type) {
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            if(!segments[3]){
                self.rows = [];
                self.showTotalSummary = false;
                if ( type.value == 'credit_note' ) {
                    self.showCreditNoteFields = true;
                    self.customer_id = null;
                    self.invoice_id = null;
                    self.vendor = null;
                    self.bill = null;
                    self.customer_error_msg = "";
                    self.invoice_error_msg = "";
                    self.vendor_error_msg = "";
                    self.bill_error_msg = "";
                    self.customerArr = [];
                    self.invoiceArr = [];
                    self.vendorArr = [];
                    self.billArr = [];
                } else {
                    self.showCreditNoteFields = false;
                    self.customer_id = null;
                    self.invoice_id = null;
                    self.vendor = null;
                    self.bill = null;
                    self.customer_error_msg = "";
                    self.invoice_error_msg = "";
                    self.vendor_error_msg = "";
                    self.bill_error_msg = "";
                    self.customerArr = [];
                    self.invoiceArr = [];
                    self.vendorArr = [];
                    self.billArr = [];
                }
                self.rows.push({
                    cr_dr_item_id:0,
                    item_id:null,
                    item_error_msg:"",
                    description:"",
                    desc_error_msg:"",
                    item_qty:0,
                    item_qtyEdit:true,
                    item_qty_error_msg:"",
                    item_price:0,
                    item_priceEdit:true,
                    item_price_error_msg:"",
                    item_amount:0,
                    tax_id:null,
                    item_total:0,
                    tax_amount:0,
                });
                self.sub_total = 0;
                self.total_tax = 0;
                self.total = 0;
            }
        },
        sub_total:function(){
            var self = this;
            self.total= self.sub_total + self.total_tax;

        },
        total_tax:function(){
            var self = this;
            self.total= self.sub_total + self.total_tax;
        },
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadFieldData(['location','taxes']);

        setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3]) {
                self.loadCreditNote();
            }else{
                self.rows.push({
                    cr_dr_item_id:0,
                    item_id:null,
                    item_error_msg:"",
                    description:"",
                    desc_error_msg:"",
                    item_qty:0,
                    item_qtyEdit:true,
                    item_qty_error_msg:"",
                    item_price:0,
                    item_priceEdit:true,
                    item_price_error_msg:"",
                    item_amount:0,
                    tax_id:null,
                    item_total:0,
                    tax_amount:0,
                });
            }
        }, 100);
        var todayDate = self.getTodayDate();
        self.optionsDate.maxDate = moment(todayDate,"MM/DD/YYYY");
        self.optionsDueDate.minDate = moment(todayDate,"MM/DD/YYYY");
        self.date_of_issue = moment(todayDate,"MM/DD/YYYY");
  },
  methods: {
    validateInput(evt, index) {
      var self = this;
      if(self.rows[index].item_price > 999999.99) {
        self.rows[index].item_priceEdit = false;
      } else {
        self.rows[index].item_priceEdit = true;
      }

    },
    isNumberCheck: function(evt,index, type) {
        var self = this;
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf('.') != -1)) {
            evt.preventDefault();
        } else {
            if(type == 'qty') {
              if(self.rows[index].item_qtyEdit) {
                return true;
              } else {
                evt.preventDefault();
              }
            } else {
              if(self.rows[index].item_priceEdit) {
                return true;
              } else {
                evt.preventDefault();
              }
            }
            return true;
        }
    },
    calculateAmount($event, index) {

        var self = this;
        if(self.rows[index].quantity==0 || self.rows[index].unit_price==0 || self.rows[index].quantity == null ||self.rows[index].unit_price == null)
        {

        }
        self.calculateTaxSubTotal();

    },
    calculateTaxSubTotal(){
        var self = this;
        var amount = 0;
        var taxAmount = 0

        self.isDisableStore = false;

        for(var i=0;i<self.rows.length;i++)
        {

            if (self.rows[i].item_qty > 0 || self.rows[i].item_price > 0 ) {

                self.rows[i].item_amount = self.rows[i].item_qty * self.rows[i].item_price;
                self.rows[i].item_amount = parseFloat(self.rows[i].item_amount);
                // self.rows[i].item_amount = self.rows[i].item_amount.toFixed(2);
                if( self.rows[i].tax_id != null && self.rows[i].tax_id != ""){
                    self.rows[i].tax_amount =  parseFloat(( self.rows[i].item_amount * self.rows[i].tax_id.percentage ) / 100);
                }else{
                    self.rows[i].tax_amount = 0;
                }
                self.rows[i].item_total = self.rows[i].item_amount;
                self.rows[i].item_total = parseFloat(self.rows[i].item_amount) + parseFloat(self.rows[i].tax_amount);
                if(self.rows[i].item_total > 999999.99) {
                  self.rows[i].item_priceEdit = false;
                  self.rows[i].item_qtyEdit = false;
                  self.rows[i].item_price_error_msg = "Amount value exceed";
                  self.isDisableStore = true;
                } else {
                  self.rows[i].item_priceEdit = true;
                  self.rows[i].item_qtyEdit = true;
                  self.rows[i].item_price_error_msg ="";

                }
                amount += parseFloat(self.rows[i].item_amount);
                taxAmount += parseFloat(self.rows[i].tax_amount);
            }
        }

        self.sub_total = parseFloat(amount);
        self.total_tax= parseFloat(taxAmount);

    },

    BackCreditNoteList() {
      var self = this;
      self.$router.push("/credit-note/list");
    },

    onSearchCustomer(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'customer', '');
        }
    },

    onSearchInvoice(search, loading) {
        var self = this;
        if (search.length > 2) {

            if (self.customer_id != null && self.customer_id.value != "") {
                loading(true);
                // self.searchField(loading, search, 'invoice', '');
                $.ajax({
                    url: process.env.ROOT_API + "/invoices/customer/search",
                    type: "POST",
                    headers: this.ajxHeaders,
                    data: {customer_id:self.customer_id.value,flag:'search',search:search},
                    crossDomain: true,
                    dataType: "json",
                    success: function (data) {
                        loading(false);
                        self.invoiceArr = [];

                        if (data.status == "success") {
                            self.invoiceArr = data.content;
                        }else{
                            self.invoiceArr = [];
                        }

                    },
                    error: function (jqXHR, exception) {
                        loading(false);
                        self.generateStatusCodeMessage(jqXHR,true,'customer-invoice-search');
                    }
                });
            }else{
                self.invoice_id = null;
                self.invoiceArr = [];
            }
        }
    },

    onSearchVendor(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'vendor', '');
        }
    },

    onSearchBill(search, loading) {
        var self = this;
        if (search.length > 2) {
            // self.searchField(loading, search, 'bill', '');
            if (self.vendor != null && self.vendor.value != "") {
                loading(true);
                $.ajax({
                    url: process.env.ROOT_API + "/bills/vendor/search",
                    type: "POST",
                    headers: this.ajxHeaders,
                    data: {vendor_id:self.vendor.value,flag:'search',search:search},
                    crossDomain: true,
                    dataType: "json",
                    success: function (data) {
                        loading(false);
                        self.billArr = [];

                        if (data.status == "success") {
                            self.billArr = data.content;
                        }else{
                            self.billArr = [];
                        }

                    },
                    error: function (jqXHR, exception) {
                        loading(false);
                        self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-search');
                    }
                });
            }else{
                self.bill = null;
                self.billArr = [];
            }
        }
    },

    onSearchSalesUser(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'user', '');
        }
    },

    onSearchComponent(search, loading){
        var self = this;
        if (search.length > 1) {
            loading(true);
            self.searchField(loading, search, 'component', '');
        }
    },

    CreateCreditNote(flag) {
      var self = this;
      var error = false;
      self.note_type_error_msg = "";
      self.customer_error_msg = "";
      self.invoice_error_msg = "";
      self.vendor_error_msg = "";
      self.bill_error_msg = "";
      self.date_of_issue_error_msg = "";
      self.reason_error_msg = "";

      if (!self.note_type || self.note_type == null || self.note_type == "") {
        self.note_type_error_msg = "Type Required.";
        error = true;
      }

      if (self.showCreditNoteFields) {

          if (!self.customer_id || self.customer_id == null || self.customer_id == "") {
            self.customer_error_msg = "Customer Required.";
            error = true;
          }

          if (!self.invoice_id || self.invoice_id == null || self.invoice_id == "") {
            self.invoice_error_msg = "Invoice Required.";
            error = true;
          }

      }else{

          if (!self.vendor || self.vendor == null || self.vendor == "") {
            self.vendor_error_msg = "Vendor Required.";
            error = true;
          }

          if (!self.bill || self.bill == null || self.bill == "") {
            self.bill_error_msg = "Vendor Invoice Required.";
            error = true;
          }
      }

      if (!self.date_of_issue || self.date_of_issue == null || self.date_of_issue == "") {
        self.date_of_issue_error_msg = "Date of Issue Required.";
        error = true;
      }

      if (!self.reason || self.reason == null || self.reason == "") {
        self.reason_error_msg = "Reason Required.";
        error = true;
      }

      for (var i = 0; i < self.rows.length; i++) {

        self.rows[i].item_error_msg = "";
        self.rows[i].desc_error_msg = "";
        self.rows[i].item_qty_error_msg = "";
        self.rows[i].item_price_error_msg = "";

        if ( (self.rows[i].item_id == null || !self.rows[i].item_id.value) && (self.rows[i].description == null || self.rows[i].description == "" ) ) {

            if ( self.rows[i].item_id == null || !self.rows[i].item_id.value ) {
                self.rows[i].item_error_msg = "Part Required.";
            }
            if ( self.rows[i].description == null || self.rows[i].description == "" ) {
                self.rows[i].desc_error_msg = "Description Required.";
            }
            error = true;
        }
        if ( self.rows[i].item_qty == null || !self.rows[i].item_qty ) {
            self.rows[i].item_qty_error_msg = "Quantity Required.";
            error = true;
        }
        if ( self.rows[i].item_price == null || !self.rows[i].item_price ) {
            self.rows[i].item_price_error_msg = "Unit Price Required.";
            error = true;
        }
      }

      if (!error) {

        self.loading = true;
        var path = window.location.pathname;
        var segments = path.split("/");

        if (segments[3])
        {
            $("#CreateCreditNoteBtn").val("Updating ...");
            $("#CreateCreditNoteBtn").prop("disabled", true);
            $("#cancelCreditNoteBtn").prop("disabled",true);
        } else {
            if (flag == "Save and Continue") {

                $("#createAndContinueCreditNoteBtn").val("Saving ...");
                $("#CreateCreditNoteBtn").prop("disabled", true);
                $("#createAndContinueCreditNoteBtn").prop("disabled", true);
                $("#cancelCreditNoteBtn").prop("disabled",true);

            } else{

                $("#CreateCreditNoteBtn").val("Saving ...");
                $("#CreateCreditNoteBtn").prop("disabled", true);
                $("#createAndContinueCreditNoteBtn").prop("disabled", true);
                $("#cancelCreditNoteBtn").prop("disabled",true);
            }
        }

        var fields = $("#creditNoteForm").serializeArray();

        fields.push({name: "note_number", value: self.note_number});
        fields.push({name: "note_type", value: self.note_type.value});

        if (self.customer_id == null) {
            fields.push({name: "customer_id", value: ""});
        } else{
            fields.push({name: "customer_id", value: self.customer_id.value});
        }

        if (self.invoice_id == null) {
            fields.push({name: "invoice_id", value: ""});
        } else{
            fields.push({name: "invoice_id", value: self.invoice_id.value});
        }

        if (self.vendor == null) {
            fields.push({name: "vendor_id", value: ""});
        } else{
            fields.push({name: "vendor_id", value: self.vendor.value});
        }

        if (self.bill == null) {
            fields.push({name: "bill_id", value: ""});
        } else{
            fields.push({name: "bill_id", value: self.bill.value});
        }

        if (self.sales_user_id == null) {
            fields.push({name: "sales_user_id", value: ""});
        } else{
            fields.push({name: "sales_user_id", value: self.sales_user_id.value});
        }

        if (self.location_id == null) {
            fields.push({name: "location_id", value: ""});
        } else{
            fields.push({name: "location_id", value: self.location_id.value});
        }

        fields.push({name: "items", value: JSON.stringify(self.rows)});
        fields.push({ name: "id", value: segments[3] });

        $.ajax({
            url: process.env.ROOT_API + "/credit-note/create",
            type: "POST",
            data: fields,
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {

                self.loading = false;
                if (segments[3])
                {
                    $("#CreateCreditNoteBtn").val("Update");
                    $("#CreateCreditNoteBtn").prop("disabled", false);
                    $("#cancelCreditNoteBtn").prop("disabled",false);
                } else {
                    if (flag == "Save and Continue") {

                        $("#createAndContinueCreditNoteBtn").val("Save and Continue");
                        $("#CreateCreditNoteBtn").prop("disabled", false);
                        $("#createAndContinueCreditNoteBtn").prop("disabled", false);
                        $("#cancelCreditNoteBtn").prop("disabled",false);

                    } else{

                        $("#CreateCreditNoteBtn").val("Save");
                        $("#CreateCreditNoteBtn").prop("disabled", false);
                        $("#createAndContinueCreditNoteBtn").prop("disabled", false);
                        $("#cancelCreditNoteBtn").prop("disabled",false);

                    }
                }

                if (data.status == "success") {

                    if (flag == "Save and Continue") {
                        $("#creditNoteForm").trigger("reset");

                        self.note_type = {text:"Credit Note",value:"credit_note"};
                        self.reference = "";
                        self.customer_id = null;
                        self.invoice_id = null;
                        self.vendor = null;
                        self.bill = null;
                        self.date_of_issue = "";
                        self.expiry_date = "";
                        self.reason = "";
                        self.sales_user_id = null;
                        self.location_id = null;
                        self.notes = "";
                        self.term_conditions = "";

                        self.rows.push({
                            cr_dr_item_id:0,
                            item_id:null,
                            item_error_msg:"",
                            description:"",
                            desc_error_msg:"",
                            item_qty:0,
                            item_qtyEdit:true,
                            item_qty_error_msg:"",
                            item_price:0,
                            item_priceEdit:true,
                            item_price_error_msg:"",
                            item_amount:0,
                            tax_id:null,
                            item_total:0,
                            tax_amount:0,
                        });

                        self.sub_total = 0;
                        self.sub_total.toFixed(2);

                        self.total_tax = 0;
                        self.total_tax.toFixed(2);

                        self.total = 0;
                        self.showTotalSummary = false;
                        var todayDate = self.getTodayDate();
                        self.date_of_issue = moment(todayDate,"MM/DD/YYYY");

                    } else{
                        self.$router.push("/credit-note/list");
                    }

                } else {

                    if (data.content.length > 0) {
                        var err = "";
                        for (var i = 0; i < data.content.length; i++) {
                            err += data.content[i] + "<br>";
                        }
                        $("#errorMsg").html(err);
                        $(".alert-warning").toggleClass("show");
                        setTimeout(function () {
                            $(".alert-warning").removeClass("show");
                            $(".alert-warning").addClass("hide");
                        }, 10000);
                    }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (segments[3])
                {
                    $("#CreateCreditNoteBtn").val("Update");
                    $("#CreateCreditNoteBtn").prop("disabled", false);
                    $("#cancelCreditNoteBtn").prop("disabled",false);
                } else {
                    if (flag == "Save and Continue") {

                        $("#PurchaseOrderForm").trigger("reset");
                        $("#createAndContinueCreditNoteBtn").val("Save and Continue");
                        $("#CreateCreditNoteBtn").prop("disabled", false);
                        $("#createAndContinueCreditNoteBtn").prop("disabled", false);
                        $("#cancelCreditNoteBtn").prop("disabled",false);

                    } else{

                        $("#CreateCreditNoteBtn").val("Save");
                        $("#CreateCreditNoteBtn").prop("disabled", false);
                        $("#createAndContinueCreditNoteBtn").prop("disabled", false);
                        $("#cancelCreditNoteBtn").prop("disabled",false);

                    }
                }
                self.generateStatusCodeMessage(jqXHR,false,'credit-debit-note-create');
            }
        });

      }else{
                self.errorValidationFocus();
      }
    },

    isNumberKey: function(evt) {

        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            evt.preventDefault();
        } else {
            return true;
        }
    },
    addRow: function () {
        var self = this;
        var index=self.rows.length-1;

        self.rows[index].item_error_msg = "";
        self.rows[index].desc_error_msg = "";
        self.rows[index].item_qty_error_msg = "";
        self.rows[index].item_price_error_msg = "";

        if ( ((self.rows[index].item_id != null && self.rows[index].item_id.value) || ( self.rows[index].description != null && self.rows[index].description != "" )) && ( self.rows[index].item_qty != null && self.rows[index].item_qty) &&
            ( self.rows[index].item_price != null && self.rows[index].item_price)) {

            self.rows.push({
                cr_dr_item_id:0,
                item_id:null,
                item_error_msg:"",
                description:"",
                desc_error_msg:"",
                item_qty:0,
                item_qtyEdit:true,
                item_qty_error_msg:"",
                item_price:0,
                item_priceEdit:true,
                item_price_error_msg:"",
                item_amount:0,
                tax_id:null,
                item_total:0,
                tax_amount:0,
            });

        }else{

            if ( (self.rows[index].item_id == null || !self.rows[index].item_id.value) && (self.rows[index].description == null || self.rows[index].description == "" ) ) {

                if ( self.rows[index].item_id == null || !self.rows[index].item_id.value ) {
                    self.rows[index].item_error_msg = "Part Required.";
                }
                if ( self.rows[index].description == null || self.rows[index].description == "" ) {
                    self.rows[index].desc_error_msg = "Description Required.";
                }
            }
            if ( self.rows[index].item_qty == null || !self.rows[index].item_qty ) {
                self.rows[index].item_qty_error_msg = "Quantity Required.";
            }
            if ( self.rows[index].item_price == null || !self.rows[index].item_price ) {
                self.rows[index].item_price_error_msg = "Unit Price Required.";
            }
        }
        if ( self.rows.length > 1) {
            self.showTotalSummary = true;
        }else{
            self.showTotalSummary = false;
        }
    },

    onTaxSelect(event,index) {
        var self = this;
        if( self.rows[index].tax_id != null && self.rows[index].tax_id != ""){
            self.rows[index].tax_amount =  parseFloat(( self.rows[index].item_amount * self.rows[index].tax_id.percentage ) / 100);
            self.rows[index].item_total = self.rows[index].item_amount + self.rows[index].tax_amount;
        }else{
            self.rows[index].tax_amount = 0;
            self.rows[index].item_total = self.rows[index].amount + self.rows[index].tax_amount;
        }
        self.calculateTaxSubTotal();
    },
    removeItem: function (index) {
        var self = this;
        if(self.rows.length > 1) {

            if (self.rows[index].cr_dr_item_id == 0) {
                self.rows.splice(index, 1);
                self.calculateTaxSubTotal();

            }else {

                if (confirm('Are you sure that you want to remove this item? ')) {

                    self.loading = true;
                    $.ajax({
                        url: process.env.ROOT_API + "/credit-note/item/delete",
                        type: "POST",
                        data: {'cr_dr_item_id': self.rows[index].cr_dr_item_id},
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            if (data.status == "success") {

                                setTimeout(function () {
                                    self.loadCreditNote();
                                },50);

                            }
                        },
                        error: function (jqXHR, exception) {
                            self.generateStatusCodeMessage(jqXHR,true,'credit-debit-note-item-remove');
                        },
                    });
                }
            }
        }
        if ( self.rows.length > 1) {
            self.showTotalSummary = true;
        }else{
            self.showTotalSummary = false;
        }
    },
    loadCreditNote() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/credit-note/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;

                if (data.status == "success") {

                    if (data.content.length > 0) {
                        self.note_number = data.content[0].note_number;
                        self.reference = data.content[0].reference;
                        self.note_type = {text:data.content[0].note_type,value:data.content[0].type};

                        if (self.note_type.value == "credit_note") {
                            self.showCreditNoteFields = true;
                        }else{
                            self.showCreditNoteFields = false;
                        }
                        self.disableNoteTypeField = true;

                        if (data.content[0].customer_id != null) {
                            self.customer_id = {text:self.titleCase(data.content[0].cus_code) + " | " + self.titleCase(data.content[0].cus_name),value:data.content[0].customer_id};
                        }else{
                            self.customer_id = null;
                        }

                        if (data.content[0].invoice_id != null) {
                            self.invoice_id = {text:data.content[0].invoice_number,value:data.content[0].invoice_id};
                        }else{
                            self.invoice_id = null;
                        }

                        if (data.content[0].vendor_id != null) {
                            self.vendor = {text:self.titleCase(data.content[0].vendor_code) + " | " + self.titleCase(data.content[0].vendor_name),value:data.content[0].vendor_id};
                        }else{
                            self.vendor = null;
                        }

                        if (data.content[0].bill_id != null) {
                            self.bill = {text:data.content[0].bill_number,value:data.content[0].bill_id};
                        }else{
                            self.bill = null;
                        }

                        if (data.content[0].location_id != null) {
                            self.location_id = {text:self.titleCase(data.content[0].loc_code) + " | " + self.titleCase(data.content[0].loc_name),value:data.content[0].location_id};
                        }else{
                            self.location_id = null;
                        }

                        if (data.content[0].sales_user_id != null) {
                            self.sales_user_id = {text:self.formatString(data.content[0].user_first_name + " " + data.content[0].user_last_name),value:data.content[0].sales_user_id};
                        }else{
                            self.sales_user_id = null;
                        }

                        self.date_of_issue = data.content[0].date_of_issue;

                        if (data.content[0].expiry_date != null) {
                            self.expiry_date = data.content[0].expiry_date;
                        }else{
                            self.expiry_date = "";
                        }

                        self.reason = data.content[0].reason;

                        if (data.content[0].notes != null && data.content[0].notes != "") {
                            self.notes = data.content[0].notes;
                        }else{
                            self.notes = "";
                        }

                        if (data.content[0].term_conditions != null && data.content[0].term_conditions != "") {
                            self.term_conditions = data.content[0].term_conditions;
                        }else{
                            self.term_conditions = "";
                        }

                        self.sub_total = data.content[0].sub_total;
                        self.total_tax = data.content[0].tax_amount;
                        self.total = data.content[0].total;

                        if (data.content[0].items.length > 0) {

                            self.rows = [];
                            var itemsArray = data.content[0].items;

                            for(var i = 0; i < itemsArray.length ; i++) {

                                self.rows.push({
                                    cr_dr_item_id: itemsArray[i].cr_dr_item_id,
                                    item_id:(itemsArray[i].item_id != undefined && itemsArray[i].item_id != null && itemsArray[i].item_id != '') ? {
                                        value: itemsArray[i].item_id,
                                        text: itemsArray[i].item_code + " | " + itemsArray[i].item_name
                                    } : null,
                                    item_error_msg:"",
                                    description:(itemsArray[i].description != undefined && itemsArray[i].description != null && itemsArray[i].description != '') ? itemsArray[i].description:null,
                                    desc_error_msg:"",
                                    item_qty: self.amountFormat(itemsArray[i].item_qty),
                                    item_qtyEdit:true,
                                    item_qty_error_msg:"",
                                    item_price: self.amountFormat(itemsArray[i].item_price),
                                    item_priceEdit:true,
                                    item_price_error_msg:"",
                                    item_amount:self.amountFormat(itemsArray[i].amount),
                                    tax_id:(itemsArray[i].tax_id != undefined && itemsArray[i].tax_id != null && itemsArray[i].tax_id != '') ? {
                                        value: itemsArray[i].tax_id,
                                        text: itemsArray[i].tax_name,
                                        percentage:itemsArray[i].tax_percentage,
                                    } : null,
                                    item_total: self.amountFormat(itemsArray[i].item_total),
                                    tax_amount: self.amountFormat(itemsArray[i].tax_amount),
                                });

                            }

                        }else{

                            self.rows.push({
                                cr_dr_item_id:0,
                                item_id:null,
                                item_error_msg:"",
                                description:"",
                                desc_error_msg:"",
                                item_qty:0,
                                item_qtyEdit:true,
                                item_qty_error_msg:"",
                                item_price:0,
                                item_priceEdit:true,
                                item_price_error_msg:"",
                                item_amount:0,
                                tax_id:null,
                                item_total:0,
                                tax_amount:0,
                            });
                        }
                        if ( self.rows.length > 1) {
                            self.showTotalSummary = true;
                        }else{
                            self.showTotalSummary = false;
                        }

                    }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'credit-debit-note-detail');
            }
        });
    },
    titleCase(str) {
        if (str == null) {
            return;
        } else {
            var value = str.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
    formatString(data) {
        var self = this;
        var value = data.replace(/_/g, " ");
        var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
            return letter.toUpperCase();
        });
        return upp;
    },
    amountFormat(amount) {
        const formatter = new Intl.NumberFormat('en-US', {
            minimumFractionDigits:2,
            maximumFractionDigits:2
        });

        return formatter.format(amount);
    },
    loadCustomerInvoices(){
        var self = this;
        if (self.customer_id != null && self.customer_id.value != "") {
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/invoices/customer/search",
                type: "POST",
                headers: this.ajxHeaders,
                data: {customer_id:self.customer_id.value,flag:'all'},
                crossDomain: true,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    self.invoiceArr = [];

                    if (data.status == "success") {
                        self.invoiceArr = data.content;
                    }else{
                        self.invoiceArr = [];
                    }

                },
                error: function (jqXHR, exception) {
                    self.generateStatusCodeMessage(jqXHR,true,'load-customer-invoice');
                }
            });
        }else{
            self.invoiceArr = [];
            self.invoice_id = null;
        }
    },
    loadVendorBills(){
        var self = this;
        if (self.vendor != null && self.vendor.value != "") {
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/bills/vendor/search",
                type: "POST",
                headers: this.ajxHeaders,
                data: {vendor_id:self.vendor.value,flag:'all'},
                crossDomain: true,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    self.billArr = [];

                    if (data.status == "success") {
                        self.billArr = data.content;
                    }else{
                        self.billArr = [];
                    }

                },
                error: function (jqXHR, exception) {
                    self.generateStatusCodeMessage(jqXHR,true,'load-vendor-invoice');
                }
            });
        }else{
            self.billArr = [];
            self.bill = null;
        }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/accounting/CreditNoteCreate.vue